import { useCallback } from 'react'

export const useHandleShowMore = () => {
    const handleShowMoreContent = useCallback(
        (
            clearCacheRow: ((rowIndex: number) => void) | undefined,
            setCacheHeight?: (cardHeight: number, rowIndex: number) => void,

            measure?: VoidFunction,
            cardRef?: React.MutableRefObject<any>,
            rowIndex?: number
        ) => {
            if (typeof rowIndex === 'number') {
                clearCacheRow?.(rowIndex)

                // Use setTimeout with requestAnimationFrame to ensure DOM has fully updated
                setTimeout(() => {
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            measure?.()
                            // Also update cache height if available
                            if (
                                cardRef?.current &&
                                setCacheHeight &&
                                rowIndex !== undefined
                            ) {
                                const height = cardRef.current.offsetHeight
                                if (height > 0) {
                                    setCacheHeight(height, rowIndex)
                                }
                            }
                        })
                    })
                }, 10) // Small delay to ensure React state update is complete
            }
        },
        []
    )

    return { handleShowMoreContent }
}
